import React from "react"
import PropTypes from "prop-types"
import { Gallery as PhotoSwipe, Item } from "react-photoswipe-gallery"
import styled from "styled-components"

const StyledImage = styled.img`
  aspect-ratio: 16 / 9;
  object-fit: cover;
  width: 100%;
  cursor: pointer;
`

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
`

const Gallery = ({ images }) => {
  return (
    <PhotoSwipe
      options={{
        hideAnimationDuration: 0,
        showAnimationDuration: 0,
      }}
    >
      <Grid>
        {images.map((image, i) => (
          <Item
            key={i}
            original={image.image}
            thumbnail={image.thumbnail}
            width="1024"
            height="768"
          >
            {({ ref, open }) => (
              <StyledImage
                ref={ref}
                onClick={open}
                src={image.thumbnail}
                alt={image.alt}
              />
            )}
          </Item>
        ))}
      </Grid>
    </PhotoSwipe>
  )
}

Gallery.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      thumbnail: PropTypes.string,
      image: PropTypes.string,
    })
  ),
}

export { Gallery }
